import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "read-another-2N2zm",
  "use": "read-another-2N2zm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"read-another-2N2zm\"><path d=\"M12 4V0H0v12h4v-2H2V2h8v2h2zm0 6V6.5h-2V10H6.5v2H10v3.5h2V12h3.5v-2H12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol